import * as React from "react";

const Files = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer2"
      fill="none"
      stroke="#000"
      strokeDasharray="none"
      strokeWidth="0.4"
      display="inline"
    >
      <path
        id="rect3"
        d="M1.588.53h2.116a.64.64 22.5 0 1 .452.186l.949.949a.64.64 67.5 0 1 .187.452v3.175a.53.53 135 0 1-.53.529H1.588a.53.53 45 0 1-.53-.53V1.059a.53.53 135 0 1 .53-.529Z"
        opacity="1"
      ></path>
      <path
        id="path3"
        strokeLinecap="round"
        strokeOpacity="1"
        d="M2.117 2.91h2.116"
        opacity="1"
      ></path>
      <path
        id="path4"
        strokeLinecap="round"
        strokeOpacity="1"
        d="m2.117 3.704 2.116-.016"
        opacity="1"
      ></path>
      <path
        id="path5"
        strokeLinecap="round"
        strokeOpacity="1"
        d="M2.117 4.498H3.44"
        opacity="1"
      ></path>
      <path
        id="path6"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeOpacity="1"
        d="M3.969.53v1.057a.265.265 45 0 0 .264.265h1.059"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Files;
